<div class="panel">
    <!--Heading-->
    <div class="panel-heading row" style="width:100%;margin-left:0px;margin-right:0px;">
        <div class="panel-control  col-xs-2" style="margin-right:30px;">
            <div class="btn-group">
                <button type="button" class="btn btn-default" (click)="logout()">退出</button>
            </div>
        </div>
        <h3 class="col-xs-2 panel-title">信息助理</h3>
        <div class="col-xs-1" style="line-height: 50px;"  *ngIf="isUserAllow()">
            <div class="btn-group">
                <a href="#learn" class="btn btn-default">去学习</a>
            </div>
        </div>
        <select class="col-xs-2" style="margin-left:30px;margin-top:10px;padding:10px;font-size:small;line-height: 50px;height:31px;padding:0 0 0 0.2em;" (change)="onSelectChatingType($event.target.value)">
            <option value="">更多聊天...选择聊天类型</option>
            <option *ngFor="let chatType of chatingTypeList | async" value= {{chatType.code}}>
               {{chatType.name}}
            </option>
      </select>
    </div>

    <!--Widget body-->
    <div id="demo-chat-body" class="collapse in">
        <div class="nano has-scrollbar" style="height:380px">
            <div class="nano-content pad-all" tabindex="0" style="right: -17px;" id="content">
                <ul class="list-unstyled media-block" #content>



                </ul>
            </div>
            <div class="nano-pane">
                <div class="nano-slider" style="height: 141px; transform: translate(0px, 0px);"></div>
            </div>
        </div>

        <!--Widget footer-->
        <div class="panel-footer">
            <div class="row">
                <div class="col-xs-9">
                    <div class="row">
                        <input type="text" id="inputmsg0" placeholder="" [(ngModel)]="message.content" class="form-control chat-input" style="margin-left:10px;height:31px;" (keyup)="keyupHandler0($event)">
                    </div>
                </div>
                <div class="col-xs-3" style="margin-top:0px">
                        <button class="btn btn-primary btn-block" (click)="add()">发送</button>
                </div>
            </div>
        </div>
    </div>
</div>

<h1>{{notifications}}</h1>